import React from 'react';
import { Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    text: t('testimonials.1.text'),
    author: t('testimonials.1.author'),
    role: t('testimonials.1.role'),
    rating: 5
  }, {
    text: t('testimonials.2.text'),
    author: t('testimonials.2.author'),
    role: t('testimonials.2.role'),
    rating: 5
  }, {
    text: t('testimonials.3.text'),
    author: t('testimonials.3.author'),
    role: t('testimonials.3.role'),
    rating: 5
  }];
  return <section className="py-32 lg:py-40 px-6 bg-[#FAFAF8]" data-id="element-241">
      <div className="max-w-7xl mx-auto" data-id="element-242">
        <div className="text-center mb-20" data-id="element-243">
          <span className="text-[10px] tracking-[0.4em] text-[#D4AF37] block mb-6 uppercase font-light" data-id="element-244">
            {t('testimonials.label')}
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light" data-id="element-245">
            {t('testimonials.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14" data-id="element-246">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-10 lg:p-12 shadow-sm hover:shadow-lg transition-all duration-500 border border-[#D4AF37]/10 group" data-id="element-247">
              {/* Stars */}
              <div className="flex gap-1 mb-8" data-id="element-248">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} size={14} className="fill-[#D4AF37] text-[#D4AF37]" strokeWidth={0} data-id="element-249" />)}
              </div>

              {/* Quote */}
              <p className="font-serif italic text-xl lg:text-2xl mb-10 leading-relaxed font-light text-gray-800" data-id="element-250">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="border-t border-[#D4AF37]/20 pt-8 group-hover:border-[#D4AF37]/40 transition-colors duration-500" data-id="element-251">
                <p className="font-medium text-sm tracking-wider mb-2" data-id="element-252">
                  {testimonial.author}
                </p>
                <p className="text-[10px] tracking-[0.3em] uppercase text-gray-500 font-light" data-id="element-253">
                  {testimonial.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}